export interface Calibration_List_Interface {
  id:number,
  code:string,
  code2:string,
  scheduleDate:string,
  customerId:number,
  customerName:string,
  customerCode:string,
  customerType:string,
  status:string,
  persianDate:string,
  username:string,
  username_img:string,
  filename:string,
  labAdderss:string,
  status_lab: number,

  letterRequestCustomer_id: string,
  letterRequestSchduleCustomer_id: string,
  letterRequestSchduleCustomer_date: string,

  visible_karshnas:boolean,
  canFunds:boolean,
  funds: number,
  evalute: number,
  requestToStatus: number,
  deviceCount:Array<number>,

  reciver_customerId:number,
  reciver_customerName:string,
  reciver_customerCode:string,

  uncertificate: number,
}

export function Empty_Calibration_List_Interface():Calibration_List_Interface{
  return{
    id:0,
    code:'',
    code2:'',
    scheduleDate:'',
    customerId:0,
    customerName:'',
    customerCode:'',
    customerType:'',
    status:'',
    persianDate:'',
    username:'',
    username_img:'',
    filename:'',
    labAdderss:'',
    status_lab: 0,
    requestToStatus: 0,

    letterRequestCustomer_id: '',
    letterRequestSchduleCustomer_id: '',
    letterRequestSchduleCustomer_date: '',

    visible_karshnas:true,
    canFunds:true,
    funds: 0,
    evalute: 0,
    deviceCount:[],

    reciver_customerId:0,
    reciver_customerName:'',
    reciver_customerCode: '',

    uncertificate:0,
  }
}
